import { configureStore } from '@reduxjs/toolkit';
import rosSlice from './slices/rosSlice';
import gazeboSlice from './slices/gazeboSlice';
import flowSlice from './slices/flowSlice';
import uiSlice from './slices/uiSlice';
import projectSlice from './slices/projectSlice';
import tutorialSlice from './slices/tutorialSlice';
import learningSlice from './slices/learningSlice';
import authSlice from './slices/authSlice';

export const store = configureStore({
    reducer: {
        auth: authSlice,
        ros: rosSlice,
        gazebo: gazeboSlice,
        flow: flowSlice,
        ui: uiSlice,
        project: projectSlice,
        tutorial: tutorialSlice,
        learning: learningSlice,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['ros/messageReceived', 'gazebo/messageReceived'],
                ignoredPaths: ['ros.messages', 'gazebo.messages'],
            },
        }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;